'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _stringify = require('../stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var style = {
  color: '#777',
  fontSize: '11px',
  padding: '4px',
  whiteSpace: 'pre',
  background: '#fff',
  overflow: 'auto'
};

exports['default'] = _react2['default'].createClass({

  displayName: 'Demo.Controls.RenderCode',

  propTypes: {
    obj: _react.PropTypes.node.isRequired,
    indentDepth: _react.PropTypes.number.isRequired
  },

  render: function render() {
    var _props = this.props;
    var obj = _props.obj;
    var indentDepth = _props.indentDepth;

    return _react2['default'].createElement(
      'div',
      { style: style, className: 'react-demo__render-code' },
      _stringify2['default'](obj, { depthLim: indentDepth })
    );
  }

});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-demo/dist/Controls/RenderCode.js
// module id = 970
// module chunks = 0